module.exports = __webpack_public_path__ + "static/img/evidence2.6535d2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/evidence2.png
// module id = uorX
// module chunks = 1 3